import { allPackagesCalculatedEvent } from './packages/package-calculator';
import initMinigallery from './packages/package-minigallery';
import { initAccordions, protectNextButtonByRadio } from './utils';

if (typeof window.com === 'undefined') window.com = {};
if (typeof window.com.parkside === 'undefined') window.com.parkside = {};

//////////////////
///// PAKETAUSWAHL
//////////////////
if (typeof window.com.parkside.pakete === 'undefined') window.com.parkside.pakete = {};
// constructor
window.com.parkside.pakete = function () {};

window.com.parkside.pakete.init_paket_selection = function () {
  initAccordions();
  protectNextButtonByRadio('package');
  initMinigallery();

  document.addEventListener(allPackagesCalculatedEvent, results => {
    document.querySelectorAll('.accordion-container .ac').forEach(acc => {
      const priceWrap = acc.querySelector(`#${acc.id} > .ac-header > .ac-trigger > .product-group-price`);

      if (!priceWrap) {
        return;
      }

      const prices = [];
      const mode = priceWrap.classList.contains('mode-gross') ? 'totalPriceGross' : 'totalPriceNet';
      acc.querySelectorAll('[data-package-id]').forEach(pcg => {
        if (pcg.dataset[mode] && pcg.dataset[`${mode}Formatted`]) {
          prices.push({ raw: pcg.dataset[mode], formatted: pcg.dataset[`${mode}Formatted`] });
        }
      });
      prices.sort((a, b) => a.raw - b.raw);
      if (prices.length === 1) {
        priceWrap.querySelector('.product-group-price-values').innerHTML = prices[0].formatted;
      } else if (prices.length > 1) {
        priceWrap.querySelector('.product-group-price-values').innerHTML = `${prices[0].formatted} - ${
          prices.pop().formatted
        }`;
      }
    });
  });
};

///////////////////////////////////////////
///// BENUTZERDEFINIERT - UNTERKONSTRUKTION
///////////////////////////////////////////
if (typeof window.com.parkside.unterkonstruktion === 'undefined') window.com.parkside.unterkonstruktion = {};
// constructor
window.com.parkside.unterkonstruktion = function () {};

window.com.parkside.pakete.init_unterkonstruktion_selection = function () {
  const inputName = 'unterkonstruktion';
  initAccordions();
  protectNextButtonByRadio(inputName);
  initMinigallery();

  document.querySelectorAll('.radio-dotted').forEach(e => {
    e.addEventListener('click', function () {
      e.querySelector('input[type="radio"]').checked = true;
    });
  });

  jQuery('.btn-next').click(function () {
    var $input = jQuery(`input[name=${inputName}]:checked`);

    if (!$input.length) {
      alert(tp_trans.trans('no_dielenausfuehrung_selected_alert', 'Wählen Sie bitte die Dielenausführung aus.'));
      return;
    }
  });
};
